import { Flex, useMantineTheme } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';
import { IconChevronRight } from '@tabler/icons-react';

import { LinkNew } from '~/domains/common/components/Link/Link';
import { Title } from '~/domains/design-system/Title';
import { Text } from '~/domains/design-system/Text';

export function HomeSectionTitle({ children }: { children: React.ReactNode }) {
  const theme = useMantineTheme();

  return (
    <Title variant="subhead-large" my={theme.spacing.lg} tag="h3" color="black">
      {children}
    </Title>
  );
}

export function HomeViewAllLink({ href, onClick }: { href: string; onClick?: () => void }) {
  const { t } = useTranslation('home');
  const theme = useMantineTheme();

  return (
    <LinkNew href={href} onClick={onClick}>
      <Flex align="center" gap={theme.other.spacing._4}>
        <Text variant="body-large" color="gray2.3">
          {t('common.viewAll')}
        </Text>
        <IconChevronRight size={16} color={theme.colors.gray2[3]} />
      </Flex>
    </LinkNew>
  );
}
